<template>
    <div class="tinymce-editor" style="width:100%">
        <editor
          ref="tinyEditor"
          v-model="content"
          :init="init"
          :disabled="disabled">
        </editor>
    </div>
</template>
<script>
import tinymce from "tinymce/tinymce";
import editor from "@tinymce/tinymce-vue";
import "tinymce/models/dom"


// 外觀
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/themes/silver";

// Icon
import "tinymce/icons/default";

// 語言包
import 'tinymce-i18n/langs5/zh_TW.js';

import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/code";
import "tinymce/plugins/preview";

export default {
  name: "tinymce-editor",
  components: {
    editor,
  }, 
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: "lists image media table wordcount lineheight link preview code charmap",
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | styles | formatselect | fontfamily | fontsize | lineheight | charmap | bold italic forecolor backcolor | bullist numlist outdent indent | cusalignLeft cusalignCenter cusalignRight alignjustify | table lists image media link | removeformat preview code",

    },
    menulist:{
      tyep:[String ,Array],
      default:""
    }

  },
  data() {
    return {
      editor :null,
      tinymceId: this.id,
      tinymceModal: {},
      init: { 
        base_url: "/tinymce/",
        language: "zh_TW",
        skin_url: "tinymce/skins/ui/oxide",
        body_class:"intaxwall",
        height: 500,
        skin: false,
        branding: false,
        menubar: false,
        link_default_target: '_blank',
        plugins: this.plugins,
        toolbar: this.toolbar,
        contextmenu: this.menulist,
        content_style: "css/BICAD.css",
        content_css:  "css/BICAD.css", 
        font_size_formats: "0.8em 1em 1.2em 1.5em 2em 2.5em 3em",
        font_family_formats: "微軟正黑體='微軟正黑體';Microsoft JhengHei;新細明體='新細明體';PMingLiU;標楷體='標楷體';DFKai-sb;Andale Mono='andale mono',monospace;Arial='arial',helvetica,sans-serif;Arial Black='arial black',sans-serif;Book Antiqua='book antiqua',palatino,serif;Comic Sans MS='comic sans ms',sans-serif;Courier New='courier new',courier,monospace;Georgia='georgia',palatino,serif;Helvetica='helvetica',arial,sans-serif;Impact='impact',sans-serif;Terminal='terminal',monaco,monospace;Trebuchet MS='trebuchet ms',geneva,sans-serif;Verdana='verdana',geneva,sans-serif",
        lineheight_formats : '1 1.5 2',
        paste_auto_cleanup_on_paste: true, 
        paste_remove_styles: true, 
        paste_remove_styles_if_webkit: true, 
        paste_strip_class_attributes: 'all',
        paste_retain_style_properties: "all",
        paste_as_text: false, 
        paste_data_images: true,
        setup:(editor)=>{
          this.editor = editor;
          editor.on('init', () => {
                editor.setContent(this.value || "");
          });
          editor.on("change", () => {
            this.content = editor.getContent();
          })
          //自訂靠左按鈕取代原功能
          editor.ui.registry.addButton("cusalignLeft", {
            icon: "align-left",
            tooltip: "靠左對齊",
            onAction: () => {
              //取得元素
              const node = editor.selection.getNode();
              //只有是圖片或表格才控制
              if (node.nodeName.toLowerCase() == "img" || 
                  node.nodeName.toLowerCase() == "td") {
                    //清空元素上會影響排版的控制STYLE
                    editor.dom.setStyle(node, "margin-left", "");
                    editor.dom.setStyle(node, "margin-right", "");
                    //取得父層 P加入靠左控制STYLE
                    const parentNode = editor.dom.getParent(node, 'div');
                    if(parentNode==null) {
                        //元素外層沒有用DIV包起來時,建立一個新DIV將其包圍
                        const rng = editor.selection.getRng();

                        // 建立 wrapper div
                        const wrapper = editor.getDoc().createElement('div');
                        wrapper.style.display = 'flex';

                        // 將 range 的內容包起來
                        rng.surroundContents(wrapper);

                        // 更新 TinyMCE 內容
                        editor.selection.setNode(wrapper);
                    } else {
                    editor.dom.setAttrib(parentNode, "style", null);
                    editor.dom.setStyles(parentNode, {
                      "display": "flex",
                    });
                    }
              } else {
                  const parentNode = editor.dom.getParent(node, 'p');
                  editor.dom.setAttrib(parentNode, "style", null);
                  //不是要控制的元素,一律使用原始的 JustifyLeft 命令来對齊左側
                  editor.execCommand("JustifyLeft");
              }
            }
          });
          //自訂中間按鈕取代原功能
          editor.ui.registry.addButton("cusalignCenter", {
            icon: "align-center",
            tooltip: "中間對齊",
            onAction: () => {
              //取得元素
              const node = editor.selection.getNode();
              //只有是圖片或表格才控制
              if (node.nodeName.toLowerCase() == "img" || 
                  node.nodeName.toLowerCase() == "td") {
                    //清空元素上會影響排版的控制STYLE
                    editor.dom.setStyle(node, "margin-left", "");
                    editor.dom.setStyle(node, "margin-right", "");
                    //取得父層 P加入靠左控制STYLE
                    const parentNode = editor.dom.getParent(node, 'div');
                    if(parentNode==null) {
                        //元素外層沒有用DIV包起來時,建立一個新DIV將其包圍
                        const rng = editor.selection.getRng();

                        // 建立 wrapper div
                        const wrapper = editor.getDoc().createElement('div');
                        wrapper.style.display = 'flex';
                        wrapper.style.justifyContent = 'center';

                        // 將 range 的內容包起來
                        rng.surroundContents(wrapper);

                        // 更新 TinyMCE 內容
                        editor.selection.setNode(wrapper);
                    } else {
                    editor.dom.setAttrib(parentNode, "style", null);
                    editor.dom.setStyles(parentNode, {
                      "display": "flex",
                      "justify-content": "center",
                    });
                    }
              } else {
                  const parentNode = editor.dom.getParent(node, 'p');
                  editor.dom.setAttrib(parentNode, "style", null);
                  //不是要控制的元素,一律使用原始的 JustifyLeft 命令来中間對齊
                  editor.execCommand("justifyCenter");
              }
            }
          });
          //自訂靠右按鈕取代原功能
          editor.ui.registry.addButton("cusalignRight", {
            icon: "align-right",
            tooltip: "靠右對齊",
            onAction: () => {
              //取得元素
              const node = editor.selection.getNode();
              //只有是圖片或表格才控制
              if (node.nodeName.toLowerCase() == "img" || 
                  node.nodeName.toLowerCase() == "td") {
                    //清空元素上會影響排版的控制STYLE
                    editor.dom.setStyle(node, "margin-left", "");
                    editor.dom.setStyle(node, "margin-right", "");
                    //取得父層 P加入靠左控制STYLE
                    const parentNode = editor.dom.getParent(node, 'div');
                    if(parentNode==null) {
                        //元素外層沒有用DIV包起來時,建立一個新DIV將其包圍
                        const rng = editor.selection.getRng();

                        // 建立 wrapper div
                        const wrapper = editor.getDoc().createElement('div');
                        wrapper.style.display = 'flex';
                        wrapper.style.justifyContent = 'flex-end';

                        // 將 range 的內容包起來
                        rng.surroundContents(wrapper);

                        // 更新 TinyMCE 內容
                        editor.selection.setNode(wrapper);
                    } else {
                    editor.dom.setAttrib(parentNode, "style", null);
                    editor.dom.setStyles(parentNode, {
                      "display": "flex",
                      "justify-content": "flex-end",
                    });
                    }
              } else {
                  const parentNode = editor.dom.getParent(node, 'p');
                  editor.dom.setAttrib(parentNode, "style", null);
                  //不是要控制的元素,一律使用原始的 JustifyLeft 命令来對齊右側
                  editor.execCommand("justifyRight");
              }
            }
          });
        },
        image_title: false,
        relative_urls: false,
        file_picker_types: "file media",
        images_upload_url: "/fileStore/d_upload/editor/",
        images_upload_handler: (blobInfo, progress) => new Promise ((resolve, reject) => {
          const uploadingElement = document.getElementById("uploading");
          uploadingElement.classList.remove("dispnone");

          var xhr, formData;
          var file = blobInfo.blob();
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/bicd/UPFile2jpg');
          xhr.onload = function() {
              const uploadingElement = document.getElementById("uploading");
              uploadingElement.classList.add("dispnone");

              var json = JSON.parse(xhr.responseText);
              if(!json.includes("/d_upload/")) {
                reject(json, {remove: true});  
              } else 
                resolve(json, {remove: true});
          };
          formData = new FormData();
          formData.append('httpPostedFile', file, file.name );
          xhr.send(formData);
          xhr.onerror = function() {
              const uploadingElement = document.getElementById("uploading");
              uploadingElement.classList.add("dispnone");

              reject('由於XHR傳輸錯誤，圖像上傳失敗。代碼:' + xhr.status)
          }
          xhr.upload.onprogress = function (e) {
              progress(e.loaded / e.total * 100);
          };
        }),
        file_picker_callback: (callback, value, meta) => new Promise ((resolve, reject) => {
          // 只允許選擇檔案
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', '.pdf,.doc,.docx,.xls,.xlsx');  // 限制檔案格式
          
          input.onchange = function() {
            var file = input.files[0];
            
            const uploadingElement = document.getElementById("uploading");
            uploadingElement.classList.remove("dispnone");

            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open('POST', '/api/bicd/UPFile2');
            xhr.onload = function() {
                const uploadingElement = document.getElementById("uploading");
                uploadingElement.classList.add("dispnone");

                var json = JSON.parse(xhr.responseText);
                if(!json.includes("/d_upload/")) {
                  callback(json, {remove: true});
                } else 
                  callback(json, {remove: true});
            };
            formData = new FormData();
            formData.append('httpPostedFile', file, file.name );
            xhr.send(formData);
            xhr.onerror = function() {
                const uploadingElement = document.getElementById("uploading");
                uploadingElement.classList.add("dispnone");

                reject('由於XHR傳輸錯誤，圖像上傳失敗。代碼:' + xhr.status)
            }
            xhr.upload.onprogress = function (e) {
                progress(e.loaded / e.total * 100);
            };
          };
          
          input.click();
          
        }),
        /*file_picker_callback: (callback, value, meta) => {
            var filetype = ".pdf, .zip, .docx, .doc, .xls, .xlsx, .odt, .ods, .odf, .mp4, .mp3, .jpg, .gif, .png";
            switch(meta.filetype) {
              case 'image':
                filetype = '.jpg, .png, .gif';
                break;
              case 'media':
                filetype = ".mp4, .mp3";
                break;
            }
            
            const node = document.createElement("div");
            
            const closenode = document.createElement("img");
            closenode.src = "/images/Backend/close.png";
            closenode.className = "iframe-close";
            closenode.onclick = function() {
              document.body.removeChild(node);
            }
            node.appendChild(closenode);

            const framenode = document.createElement("iframe");
            framenode.src = "/fileManager";
            framenode.id = "framenode";
            framenode.className = "iframe";
            node.appendChild(framenode);
            document.body.appendChild(node);

            window.addEventListener("message", (event) => {
              const fileUrl = event.data;
              callback(fileUrl["message"]);
              document.body.removeChild(node);
              window.removeEventListener("message");
            })
        },*/
      },

      content: this.value,
    };
  },
  mounted() {
    //tinymce.init({});
  },

  methods: {
   },
  watch: {
    value(newValue) {
        this.content = newValue;
          setTimeout(() => {
              if (this.editor.getContent() !== newValue) {
                  this.editor.setContent(newValue || "");
              }
          });
    },
    content(newValue){
      this.$emit("input",newValue);
    }
  },
};

function getPasteOption() {
  return {
    paste_preprocess: (editor, args) => {
    },
    paste_webkit_styles: "color",  
    paste_auto_cleanup_on_paste: true, //自動清理貼上內容
    paste_remove_styles: true, //移除貼上內容的樣式
    paste_remove_styles_if_webkit: true, //如果是WebKit瀏覽器,也移除樣式
    paste_strip_class_attributes: 'all', //移除所有class屬性
    paste_retain_style_properties: "all",
    paste_as_text: false, //以純文字形式貼上
  };
}

   
</script>